import { ImageIcon, Loader2 } from 'lucide-react';
import React, { useState } from 'react'
import toast from 'react-hot-toast';

export default function PrescriptionBannerForm  ({ initial, onSubmit, onClose }) {
  const [vals, setVals] = useState({
    contact_number: initial?.contact_number || "",
    image: null,
  });
  const [preview, setPreview] = useState(initial?.image_url || null);
  const [submitting, setSubmitting] = useState(false);

  const handleImage = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setVals((p) => ({ ...p, image: file }));
    setPreview(URL.createObjectURL(file));
  };

  const handleSubmit = async () => {
    if (!vals.contact_number) return toast.error("WhatsApp number required");
    if (!initial && !vals.image) return toast.error("Banner image required");
    setSubmitting(true);
    await onSubmit(vals);
    setSubmitting(false);
  };

  return (
    <div className="space-y-5">
      {/* Image Upload */}
      <div>
        <label className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2 block">
          Banner Image {!initial && <span className="text-red-500">*</span>}
        </label>
        <div
          onClick={() => document.getElementById("pb-image-input").click()}
          className="border-2 border-dashed border-gray-200 dark:border-gray-600 hover:border-blue-400 rounded-xl p-4 cursor-pointer transition-all group"
        >
          {preview ? (
            <div className="relative">
              <img src={preview} alt="Preview" className="w-full h-36 object-cover rounded-lg" />
              <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-all rounded-lg flex items-center justify-center">
                <span className="text-white text-xs font-semibold">Click to change</span>
              </div>
            </div>
          ) : (
            <div className="flex flex-col items-center gap-2 py-4">
              <div className="w-10 h-10 bg-blue-50 dark:bg-blue-900/20 rounded-xl flex items-center justify-center">
                <ImageIcon className="w-5 h-5 text-blue-500" />
              </div>
              <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Click to upload banner image</p>
              <p className="text-xs text-gray-400">JPG, PNG supported</p>
            </div>
          )}
        </div>
        <input id="pb-image-input" type="file" accept="image/*" className="hidden" onChange={handleImage} />
      </div>

      {/* WhatsApp Number */}
      <div>
        <label className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2 block">
          WhatsApp Number <span className="text-red-500">*</span>
        </label>
        <div className="flex items-center border border-gray-200 dark:border-gray-600 rounded-xl overflow-hidden focus-within:ring-2 focus-within:ring-blue-500">
          <span className="px-3 py-2.5 bg-gray-50 dark:bg-gray-700 text-sm text-gray-500 border-r border-gray-200 dark:border-gray-600 font-medium">
            +91
          </span>
          <input
            type="tel"
            maxLength={10}
            value={vals.contact_number}
            onChange={(e) => setVals((p) => ({ ...p, contact_number: e.target.value }))}
            placeholder="10-digit WhatsApp number"
            className="flex-1 px-3 py-2.5 text-sm bg-transparent outline-none text-gray-800 dark:text-gray-200"
          />
        </div>
      </div>

      {/* Actions */}
      <div className="flex justify-end gap-3 pt-2">
        <button onClick={onClose} className="btn-secondary">Cancel</button>
        <button onClick={handleSubmit} disabled={submitting} className="btn-primary flex items-center gap-2">
          {submitting && <Loader2 className="w-4 h-4 animate-spin" />}
          {initial ? "Update Banner" : "Add Banner"}
        </button>
      </div>
    </div>
  );
};
